import React from 'react';

import { Text } from '@rbilabs/universal-components';
import { View } from 'react-native';

import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

import { TermsLink } from './styled';

const Bullet = ({ label, value }: { label: string; value: string }) => (
  <View style={{ marginBottom: 8 }}>
    <Text variant="body" fontWeight="bold">
      • {label}{' '}
      <Text variant="body" fontWeight="normal">
        {value}
      </Text>
    </Text>
  </View>
);

export const DeliveryTermsCanada = () => {
  return (
    <>
      <Text variant="headerThree" mb="$4">
        {t('deliveryTerms.title.ca')}
      </Text>
      <Text variant="body" mb="$4">
        {t('deliveryTerms.intro.ca.part1')}
      </Text>
      <Text variant="body" mb="$4">
        {t('deliveryTerms.intro.ca.part2')}
      </Text>
      <Text variant="body" mb="$4">
        {t('deliveryTerms.intro.ca.part3')}
      </Text>

      <Text variant="headerThree" mb="$2">
        {t('deliveryTerms.ca.heading')}
      </Text>
      <View style={{ paddingLeft: 16 }}>
        <Bullet
          label={t('deliveryTerms.fee.ca.lt12.label')}
          value={t('deliveryTerms.fee.ca.lt12.value')}
        />
        <Bullet
          label={t('deliveryTerms.fee.ca.gte12.label')}
          value={t('deliveryTerms.fee.ca.gte12.value')}
        />
      </View>

      <TermsLink to={routes.mobileOrderTerms}>
        <Text variant="headerThree" mt="$4">
          {t('deliveryTerms.ca.mobileTitle')}
        </Text>
      </TermsLink>
    </>
  );
};
